import React from "react"

interface WidgetPartnersProps {
    partners: { url: string, data: { imgSrc: string, imgAlt: string } }[];
}

export const WidgetPartners: React.FC<WidgetPartnersProps> = ({ partners }) => {
    return (
        <div className="p-4">
            <ul className="list-unstyled list-style mb-0 d-flex flex-wrap align-items-center">
                {partners.map(({ url, data: { imgSrc, imgAlt } }) => (
                    <li key={imgSrc} className="mb-3">
                        <a href={url} target="_blank" title={imgAlt}>
                            <img src={imgSrc} alt={imgAlt} className="w-100" />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default WidgetPartners;